import Vue from "vue";
import url from "./apiUrls";
import { store } from "../../store/store";

export const fileUploadApis = new Vue({
  methods: {
    videoUpload(videoData, token) {
      const accessToken = token ? token : store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${accessToken} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.videoUpload, videoData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    imageUpload(imageData, token) {
      const accessToken = token ? token : store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${accessToken} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.imageUpload, imageData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
